export class Config {
    constructor(public host: string, public apiKey: string, public useDefaultSelect: boolean,
        public defaultSelectText: string) {

    }
}
